import { setParentalAge, setParentalIsEnabled } from 'actions/parental-lock';
import { showToast } from 'actions/toast';

export default dispatch => ({
  setParentalAge: age => dispatch(setParentalAge(age)),
  setParentalIsEnabled: isparentalEnabled => dispatch(setParentalIsEnabled(isparentalEnabled)),
  showToast: data => dispatch(showToast(data)),
});
